import CustomStyle from '@/components/Common/CustomStyle';
import AppVersion from '@/components/Common/AppVersion';
import TwoFactorInstruction from '../LayoutLeftPanels/TwoFactorInstruction.vue';

export default {
  name: 'LayoutWrapper',
  components: {
    CustomStyle,
    AppVersion,
    TwoFactorInstruction,
  },
  data() {
    return {
      leftPanels: {
        two_factor_setup: TwoFactorInstruction,
      },
    };
  },
  props: {
    brandTheme: Object,
    brandLogo: String,
    logoAboveForm: String,
    supportEmail: null,
  },
  computed: {
    formType() {
      return this.$store.getters['authServicesPoints/form'].type;
    },
    currentLeftPanel() {
      return this.leftPanels[this.formType] || null; 
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/LayoutWrapper/component.js